import axios from "axios";
import {baseUrl} from "@/api/config";

const instance = axios.create({
  // 判断开发 测试 生产环境
  baseURL: process.env.NODE_ENV === "production" ? (/\/\/www\./.test(window.location.origin) ? baseUrl.pro : baseUrl.dev) : baseUrl.dev,
  // baseURL: baseUrl.dev,
  timeout: 60000,
});

//get请求
export function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    instance
      .get(url, {
        params: params,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

//post请求
export function post(url, data = {}) {
  let params = new URLSearchParams();
  for (let key in data) {
    params.append(key, data[key]);
  }
  return new Promise((resolve, reject) => {
    instance.post(url, params).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

//图片上传
export function upload(url, formData) {
    return new Promise((resolve, reject) => {
        instance.post(url, formData).then(
            (response) => {
                resolve(response.data);
            },
            (err) => {
                reject(err);
            }
        );
    });
}
